/* eslint-disable */

import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import VueRouter from "vue-router";
import router from "./router";
import UserManager from "./services/manager/UserManager";
import ProjectsManager from "./services/manager/ProjectsManager";
import "./plugins/vuetify-money.js";
import SentryService from "./services/sentryService";

Vue.config.productionTip = false;
Vue.prototype.$UserManager = UserManager;
Vue.prototype.$ProjectsManager = ProjectsManager;

Vue.use(VueRouter);
Vue.use(UserManager);
Vue.use(ProjectsManager);

SentryService.init();

new Vue({
  vuetify,
  render: (h) => h(App),
  router,
}).$mount("#app");
